/**
 * Define Main top app bar mixin
 *
 * @author minkyoung.park@emcast.com
 */
export const topAppBarMixin = {
    data() {
        return {
            leftBtnMode: '',
            rightBtnMode: '',
            title: localStorage.getItem('brandName'),
            leftBtnMethod: '',
            rightBtnMethod: '',
            topAppBar: null,
            drawer: null,
            drawerList: null
        }
    },

    methods: {

        setTopAppBarHomeBlank(title) {
            this.leftBtnMode = 'menu'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = ''
            this.rightBtnMethod = ''
        },

        setTopAppBarHomeSearch(title) {
            this.leftBtnMode = 'menu'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarBackSearch(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
                //this.$router.go(-1)
                this.moveParentRouter()
            }
            this.rightBtnMethod = ''
        },
        setTopAppBarBack(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
            this.$router.go(-1)
            }
            this.rightBtnMethod = ''
            },
        setTopAppBarBackPreviousPage() {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.moveParentRouter()
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarClosePopup(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                //this.$router.push('/learn?status=LEARNING')
                //this.$router.push('/degree?type=ListTotal')
                this.$router.push('/home');
            }
            this.rightBtnMethod = ''
        },
        setTopAppBarCloseOnlyMoveLogin(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$moveLogin()
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarTitleOnly(title) {
            this.leftBtnMode = ''
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = ''
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
                //this.moveParentRouter()
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarBackHelpDesk(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
        setTopAppBarCloseSocialPopup(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
        setTopAppBarBackPortfolio(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
                //this.$router.go(-1)
                this.$router.push({
                    name: 'Portfolio'
                })
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarBackReward() {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = ''
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarBackToMyInformation(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.push({
                    name: 'MyInformation'
                })
            }
            this.rightBtnMethod = ''
        },
        setTopAppBarBackToMyIndependent(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = 'search'
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
        toggleDrawer() {
            this.drawer.open = !this.drawer.open
        },

        moveParentRouter() {
            let routerLen = this.$route.matched.length
            console.log('moveParentRouter', this.$route.matched, routerLen)
            if (routerLen === 1) {
                // this.$router.push({
                //     name: 'Main'
                // })
                this.$router.push('/home')
                //this.$router.push('/degree?type=ListTotal')
                //this.$router.push('/learn?status=LEARNING')
            } else {
                let query = this.$route.query
                this.$router.push({
                    name: this.$route.matched[routerLen - 2].name,
                    query: query
                })
            }
        },

        setTopAppBarCustom(setValue) {
            this.leftBtnMode = setValue.leftBtnMode
            this.rightBtnMode = setValue.rightBtnMode
            this.title = setValue.title
            this.leftBtnMethod = setValue.leftBtnMethod
            this.rightBtnMethod = setValue.rightBtnMethod
        }
    }
}
